//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[[0,"CodeRule",1,0]],[[["codeType"],"SetCodeType",{},1,0],[["qrCodeBuilder"],"SetQRCodeBuilder",{},1,0],[["barCodeBuilder"],"SetBarCodeBuilder",{},1,0],[[],"GetTargetObjectForQRCode",{R_:{targetObj:"Plane"}},0,0],[["targetObj"],"SetTargetObjectForQRCode",{},1,0],[[],"GetTargetObjectForBarCode",{R_:{targetObj:"Plane"}},0,0],[["targetObj"],"SetTargetObjectForBarCode",{},1,0],[[],"DeleteBarCode",{},0,0],[[],"DeleteQRCode",{},0,0],[[],"GenerateQRCode",{},0,0],[[],"EditBarCodeText",{},0,0],[[],"GenerateBarCode",{},0,0]],[]];
SPLM.Tooling.InsertQRBarCodeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.InsertQRBarCodeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.InsertQRBarCodeBuilder.Code = Object.freeze({
    "QRCode" : "QRCode", "BarCode" : "BarCode"});

export default SPLM;